import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {"stack" | "inline"} props.variant
 * @param {string} props.tooltipText
 * @param {string} props.error
 * @param {boolean} props.disabled
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Group({
  label = '',
  variant = 'stack',
  tooltipText = '',
  error = null,
  disabled = false,
  className = '',
  children = null
}) {
  return (
    <UiKit.Grid templateColumns="1fr" gap="4" className={className}>
      <UiKit.Title size="sm" tooltipText={tooltipText}>
        {label}
      </UiKit.Title>
      <div data-layout={variant} className={styles.options}>
        {children}
      </div>
      <UiKit.Error msg={error} hide={disabled} />
    </UiKit.Grid>
  );
}
